import _ from 'underscore';
import 'core-js/fn/array/includes';

const service = [];

const fn = () => {
    const ApiFactory = {};

    /**
     * Entry point for the parsing of an HTTP API response. Attempts to verify whether the response from the server is
     * valid and if valid, indicates a successful request or not.
     *
     * @param response object Original response object
     * @returns {object} The response object after parsing
     */

    ApiFactory.parse = function(response) {
        const isResponseValid = ApiFactory.verifyResponseFormat(response);

        if(!isResponseValid) {
            return ApiFactory.responseObject(false, ApiFactory.verifyResponseFormatErrorMsg);
        }

        const status = response.status === 'success';

        return ApiFactory.responseObject(status, response);
    };

    /**
     * Configures an upated response object now that we've determined whether the request was successful or not.
     *
     * @param status bool True of successful request, otherwise false.
     * @param response The original response.
     * @returns {{status: *, msg: Array, data: {object}}}
     */

    ApiFactory.responseObject = function(status, response) {
        let _status = status;
        let data = {};

        if(typeof status !== 'boolean') {
            _status = false;
        }

        if(_.isObject(response.data) && response.data !== null) {
            data = response.data;
        }

        return {
            status: _status,
            msg: response.msg,
            data,
        };
    };

    /**
     * Verifies the format of the response. If error is detected then ApiFactory.verifyResponseFormatErrorMsg is
     * populated with an internal error message.
     *
     * @param response object Original response object
     * @returns {boolean}
     */

    ApiFactory.verifyResponseFormat = function(response) {
        try {
            ApiFactory.throwIfNot(response, 'object');

            ApiFactory.throwIfNot(response.status, 'string');

            ApiFactory.throwIfNotEq(response.status, ['success', 'error']);

            ApiFactory.throwIfNot(response.error, 'undefined');

            if(typeof response.msg === 'undefined') {
                return true;
            }

            ApiFactory.throwIfNotStringOrObject(response.msg);

            ApiFactory.verifyResponseMessageObject(response.msg);
        } catch(e) {
            ApiFactory.verifyResponseFormatErrorMsg = e.message;

            return false;
        }

        return true;
    };

    ApiFactory.throwIfNot = (input, type) => {
        if(typeof input !== type) {
            throw new Error(`Not a ${type}`);
        }
    };

    ApiFactory.throwIfNotEq = (input, value) => {
        if(Array.isArray(value)) {
            ApiFactory.throwIfNotEqArray(input, value);

            return;
        }

        if(input !== value) {
            throw new Error('Not equal', [input, value]);
        }
    };

    ApiFactory.throwIfNotEqArray = (input, value) => {
        if(!value.includes(input)) {
            throw new Error('Not equal', [input, value]);
        }
    };

    ApiFactory.throwIfNotStringOrObject = (input) => {
        if(!_.isObject(input) && !_.isString(input)) {
            throw new Error('response.msg is not an string or object');
        }
    };

    ApiFactory.verifyResponseMessageObject = (input) => {
        if(!_.isObject(input)) {
            return;
        }

        ApiFactory.verifyResponseMessageMsgs(input);
    };

    ApiFactory.verifyResponseMessageMsgs = (input) => {
        for(const key in input) {
            if(!input.hasOwnProperty(key)) {
                continue;
            }

            if(!Array.isArray(input[key])) {
                throw new Error('Is not an array', key);
            }

            input[key].map(ApiFactory.verifyResponseMessageObjectStringIsString);
        }
    };

    ApiFactory.verifyResponseMessageObjectStringIsString = (indMsg) => {
        if(typeof indMsg !== 'string') {
            throw new Error(`[${indMsg}] is not a string.`);
        }
    };

    return ApiFactory;
};

service.push(fn);

export default service;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/services/SimpleApiFactory.js